import { SwitchButtonGroup } from "@/common/components/SwitchButtonGroup";

export type SegmentViewType = "companies" | "users";

interface SegmentViewToggleProps {
  viewType: SegmentViewType;
  onViewTypeChange: (viewType: SegmentViewType) => void;
}

export function SegmentViewToggle({
  viewType,
  onViewTypeChange,
}: SegmentViewToggleProps) {
  return (
    <SwitchButtonGroup<SegmentViewType>
      buttons={[
        { id: "companies", label: "Companies" },
        { id: "users", label: "Users" },
      ]}
      layoutId="segment-view-toggle"
      size="sm"
      value={viewType}
      variant="outline"
      onChange={onViewTypeChange}
    />
  );
}
